import { Event } from "../../contracts";
// import { getCurrentTime } from "sb-resp-lib";
import { getISODate } from "../getISODate";

export const mapStartDateTime = (event: Event, currentTimeZone: number, dateFormat: string, timeFormat: string) => {
    let eventDate = getISODate(event.startEventDate, currentTimeZone);
    event.eventDate = eventDate ? eventDate.formatDate(dateFormat) : "--";
    event.eventTime = eventDate ? eventDate.formatDate(timeFormat) : "--";

    return event;
}